import { createBrowserHistory, createHashHistory } from "history";

const strategy = window.appConfig.history_strategy;
export default strategy === "hashHistory" ? createHashHistory() : createBrowserHistory();
